import React, { useState, useEffect, useContext } from "react";
import { Modal, Button, Container, Row, Col } from "react-bootstrap";
import dateFormat from "dateformat";
import { BsCalendarMinusFill, BsExclamationCircleFill, BsPlusLg } from "react-icons/bs";
import Swal from 'sweetalert2'
import AuthContext from "../../../auth/authContext";
import { TODIS_UPD_REQUEST, UPD_REQUEST } from "../../../.config/form/network_performance";
import style from "../Modal.module.scss";
import "../../../pages/DataCollection/style.css";
import { TODIS_FORM_FIELD_DATE_RQ, TODIS_FORM_FIELD_DATE_YEAR, TODIS_FORM_FIELD_OPTIONS_DESC } from "../../Forms";
import { RequestService } from "../../../HttpService/RequestService";
import { Form, Formik } from "formik";

const MODAL_UPD_REQUEST = ({ pushRequest, listSectionActive, ...restProps }) => {

    const { user } = useContext(AuthContext);

    const [personals, setPersonals] = useState([
        {
            idAuxtabledetail: "john.doe",
            txtDescription: "John Doe"
        }
    ]);

    useEffect(() => {
        getRegionalUsers();
    }, []);

    const getRegionalUsers = async () => {
        let users = await new RequestService("workflow/request/regionals").get();
    
        // Ordenar los usuarios alfabéticamente por first_name y luego por last_name
        users.sort((a, b) => {
            const nameA = a.first_name.toLowerCase(); // Convertir a minúsculas para la comparación
            const nameB = b.first_name.toLowerCase();
            if (nameA < nameB) return -1; // a va antes que b
            if (nameA > nameB) return 1; // b va antes que a
            // Si son iguales, comparar por last_name
            const lastNameA = a.last_name.toLowerCase();
            const lastNameB = b.last_name.toLowerCase();
            if (lastNameA < lastNameB) return -1;
            if (lastNameA > lastNameB) return 1;
            return 0; // Son iguales
        });
    
        let persons = users.map((itm) => {
            return {
                "idAuxtabledetail": itm.username,
                "txtDescription": itm.first_name + " " + itm.last_name
            }
        });
        //console.log("persons data", persons)
        if (users)
            setPersonals(persons);
    }
    

    const createUpdateRequest = async (values, { resetForm }) => {
        const loadingSwal = Swal.fire({
            title: 'Processing...',
            text: 'Please wait while we process your request.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        const listRequest = [];
        listSectionActive.map(item =>
            listRequest.push({ "formId": item.form_id, "sectorId": item.transportType, "moduleId": item.projectType })
        );
        try {
            const res = await new RequestService("workflow/bulk/request/" + user.username)
                .createUpdateRequest({ formIds: listRequest, validFor: values.validOf.year.toString(), assignedTo: values.assignedTo });

            // Tratamiento de errores parciales
            if (res && res.status === 201 && res.data) {
                Swal.close();
                const backendData = res.data.data;
                const successIds = backendData?.successIds || [];
                const errors = backendData?.errors || [];

                if (errors.length > 0) {
                    // Hay errores parciales
                    let errorMsg = `<b>Some requests failed:</b><br>`;
                    if (successIds.length > 0) {
                        errorMsg += `<span style="color:green">Success IDs:</span> ${successIds.join(', ')}<br>`;
                    }
                    const errorIds = errors.map(err => err.formId);
                    errorMsg += `<span style="color:red">Error IDs:</span> ${errorIds.join(', ')}<br>`;
                    Swal.fire({
                        position: 'center',
                        icon: 'warning',
                        title: 'Partial Success',
                        html: errorMsg,
                        showConfirmButton: true
                    });
                } else {
                    // Todo OK
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Your request has been saved',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    resetForm();
                    restProps.onHide();
                    pushRequest();
                }
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: 'There was an error while creating the update request.',
                    showConfirmButton: true
                });
            }
        } catch (error) {
            console.log("error create update Request", error);
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: 'An unexpected error occurred while creating the update request.',
                showConfirmButton: true
            });
        }
    }

    return (
        <Modal
            {...restProps}
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName={style.todisModalContainer}
            dialogClassName={style.sizeModal50}
            centered
        >
            <Modal.Header closeButton className={style.modalHeader}>
                <Modal.Title id="contained-modal-title-vcenter" className={style.modalTitle}>
                    <BsCalendarMinusFill className="me-3" />Creating New Update Data Collection Request
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container fluid className="todis-form-wrapper p-3" style={{ height: "100%" }}>
                    <Row>
                        <Formik
                            initialValues={UPD_REQUEST}
                            validationSchema={TODIS_UPD_REQUEST}
                            onSubmit={createUpdateRequest}>
                            {({ errors, touched, values, setFieldValue }) => (
                                <Form className="todis-form-content p-0">
                                    <Container>
                                        <Row>
                                            <Col lg={6}>
                                                <TODIS_FORM_FIELD_OPTIONS_DESC id="assignedTo" label="ASSIGNED TO" name="assignedTo" type="select" options={personals} />
                                                {errors.assignedTo && touched.assignedTo ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.assignedTo}</div>) : null}
                                            </Col>
                                            <Col lg={6}>
                                                <TODIS_FORM_FIELD_DATE_YEAR id="validOf" label="VALID OF" name="validOf" setFieldValue={setFieldValue} />
                                                {errors.validOf && touched.validOf ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.validOf}</div>) : null}
                                            </Col>
                                            <div className="todis-action-form">
                                                <Button variant="outline-danger" onClick={() => restProps.onHide()} className={style.todisBtnOutline}>DISCARD </Button>
                                                <Button variant="primary" className="todis-submit-btn bck-btn-secundary" type="submit" style={{ margin: "0.5rem" }}><BsPlusLg className="me-3" />CREATE REQUEST </Button>
                                            </div>
                                        </Row>
                                    </Container>
                                </Form>
                            )}
                        </Formik>
                    </Row>
                </Container>
            </Modal.Body>
        </Modal>
    )
}

export { MODAL_UPD_REQUEST };